import React, {useEffect} from 'react';
import CONSTANTS from '../../constants';
import ElasticAppHarness from '../ElasticAppHarness';
import utils from '../../utils';
import { useAuth0 } from '@auth0/auth0-react';

function NewsApp({ tenantSetting, preview=false, forceTags=null }) {
    //if preview, only show small bits
    //if preview, filter to newest news


    let tenID = utils.getForceTenantValue();

    if(!tenID) {
        //if no currently set forceTenantValue, get the id from the agility record, and set it in localstorage
        tenID = tenantSetting.tenant.fields.aDGroupID || null;
        utils.setForceTenantValue(tenID);
    }

    const trackCall = async () => {
        let accToken = await utils.getAccessToken(getAccessTokenSilently, user);
        if(!preview) {
          //no await on purpose, we don't need to ensure that it returns - just issue it
          utils.trackAppView('news', tenID, accToken);
        }
    }

    const { user, getAccessTokenSilently } = useAuth0();
    
    const metaData = [
        //TITLE: What should display on UI
        //DISPLAYFIELD: What is stored in CONSTANTS
        //FILTERFIELD: JSON field to filter the master list on
        {title:'Sort By', displayField: 'sort_by_recent'},
        {title:'Date Range', displayField: 'date_range_filter'}
  
    ]

    useEffect(() => {
        // only track if on prod
        if(process.env.REACT_APP_ENV === 'PROD' ) {
            trackCall();
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            <ElasticAppHarness
                headerText='News' 
                tenantSetting={tenantSetting} 
                appType={CONSTANTS.APPS_BY_NAME.NEWS} 
                pageType={CONSTANTS.ELASTIC_PAGE_TYPES.NEWS} 
                preview={preview}
                metaData={metaData} />
        </>
    )
}

export default NewsApp
